// extracted by mini-css-extract-plugin
module.exports = {"errors":"ProfileObjectModificationResultModal_errors__3aae3","footer":"ProfileObjectModificationResultModal_footer__29YOU"};